<template>
  <!-- 文章列表 -->
  <div class="groupBind">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['分组控销', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增关系</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleStatus('', 'D')"
          >批量删除</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="启用" value="Y"></el-option>
          <el-option label="禁用" value="N"></el-option>
        </el-select>
        <label class="label">关系：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="关系"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="销售" value="销售"></el-option>
          <el-option label="禁售" value="禁售"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="关系名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" type="index">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="分组编号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsName"
        align="center"
        show-overflow-tooltip
        label="商品组"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        align="center"
        show-overflow-tooltip
        label="客户组"
      >
        <!-- <template slot-scope="scope">
          <div>{{ scope.row.userName }}-({{ scope.row.type }})</div>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="addTime"
        label="时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 'N'">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == 'Y'">已启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row.id, 'D')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 新增分组 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑关系</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="商品组" prop="goodsId">
              <el-input
                v-model="addForm.goodsName"
                placeholder="单击选择"
                readonly
                @click.native="setGetData('商品')"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户组" prop="userId">
              <el-input
                v-model="addForm.userName"
                placeholder="单击选择"
                readonly
                @click.native="setGetData('客户')"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="addForm.status"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="启用" value="Y"></el-option>
                <el-option label="禁用" value="N"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关系" prop="type">
              <el-select
                v-model="addForm.type"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="销售" value="销售"></el-option>
                <el-option label="禁售" value="禁售"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      title="数据选择"
      :isSelBox="isSelBox"
      :selBoxName="selBoxName"
      :selBoxList="selBoxList"
      :selBoxValue="searchData.type"
      :searchValue="searchData.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageData"
      :allPage="allPageData"
      @search="getDataList"
      @selBox="setSelBox"
      @rowClick="rowClick"
      @hanCurrChange="hanChangeData"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "groupBind",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        name: "",
        status: "",
        type: "",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: "",
        goodsId: "",
        goodsName: "",
        userId: "",
        userName: "",
        type: "销售",
        status: "Y",
      },
      addFormRule: {
        goodsId: [mustFill],
        userId: [mustFill],
        type: [mustFill],
        status: [mustFill],
      },
      // 数据选择
      dialogVisible: false,
      searchData: {
        name: "",
        type: "",
        status: "Y",
      },
      isSelBox: false,
      selBoxName: "组类型",
      selBoxList: [
        { label: "客户组", value: "客户组" },
        { label: "企业组", value: "企业组" },
        { label: "区域组", value: "区域组" },
      ],
      tableList: [],
      tableHead: {},
      currPageData: 1,
      allPageData: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        type: "ControlRelationshipList",
        mold: this.searchForm.type,
        status: this.searchForm.status,
        parameter: this.searchForm.name,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      let proc = "Proc_OperationControl"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = 1;
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = (res.data || []).map((item) => ({
              id: item.Id,
              goodsId: item.SId,
              goodsName: item.SName,
              userId: item.BId,
              userName: item.BName,
              type: item.Mold,
              addTime: item.RecordTime,
              status: item.Beactive,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**更改状态 */
    handleStatus(id, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == "Y") {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == "N") {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == "D") {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          id = id || this.selectedList.map((item) => item.id).join(",");
          let data = {
            type: "ControlRelationshipProcessing",
            list: id,
            ident: status,
          };
          let proc = "Proc_OperationControl"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (const key in this.addForm) {
          this.addForm[key] = row[key];
        }
      }
      this.addDrawer = true;
    },
    setGetData(type) {
      if (type == "商品") {
        this.searchData.type = "商品组";
        this.isSelBox = false;
      } else if (type == "客户") {
        this.searchData.type = "客户组";
        this.isSelBox = true;
      }
      this.getDataList("");
    },
    setSelBox(val) {
      this.searchData.type = val;
      this.getDataList("");
    },
    // 获取弹出框表格数据
    getDataList(val, isRep) {
      this.searchData.name = isRep ? val : this.searchData.name;
      let data = {
        type: "ControlSummaryList",
        mold: this.searchData.type,
        status: this.searchData.status,
        parameter: this.searchData.name,
        PageIndex: this.currPageData,
        PageSize: 10,
      };
      let proc = "Proc_OperationControl"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableHead = res.fdname;
            this.allPageData = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanChangeData(val) {
      this.currPageData = val;
      this.getDataList();
    },
    // 选择单条数据
    rowClick(row) {
      console.log(row, "2323");
      if (this.searchData.type == "商品组") {
        this.addForm.goodsId = row.Id;
        this.addForm.goodsName = row.Name;
      } else {
        this.addForm.userId = row.Id;
        this.addForm.userName = row.Name + "-" + row.Mold;
      }
      this.dialogVisible = false;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addForm.type = "销售";
      this.addForm.status = "Y";
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "ReplaceControlRelationship",
            id: this.addForm.id,
            sid: this.addForm.goodsId,
            sname: this.addForm.goodsName,
            bid: this.addForm.userId,
            bname: this.addForm.userName,
            mold: this.addForm.type,
            status: this.addForm.status,
          };
          let proc = "Proc_OperationControl"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "rechargeorder/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.groupBind {
  width: 100%;
  height: 100%;
}
</style>
